import { render } from "./InstagramModal.vue?vue&type=template&id=035e307c&scoped=true"
import script from "./InstagramModal.vue?vue&type=script&lang=js"
export * from "./InstagramModal.vue?vue&type=script&lang=js"

import "./InstagramModal.vue?vue&type=style&index=0&id=035e307c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035e307c"]])

export default __exports__